import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axiosInstance from "../../../utils/axiosInstance";

// Modify the thunk to accept search parameters for name, startDate, and endDate
export const mediaTemplateApi = createAsyncThunk("mediaTemplate", async () => {
  const response = await axiosInstance.get(`/getmediatemplate`);
  return response.data;
});

const mediaTemplateSlice = createSlice({
  name: "mediaTemplate",
  initialState: {
    mediaTemplate: [],
    errors: [],
    loading: false,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(mediaTemplateApi.pending, (state) => {
        state.loading = true;
      })
      .addCase(mediaTemplateApi.fulfilled, (state, action) => {
        state.mediaTemplate = action.payload;
        state.loading = false;
      })
      .addCase(mediaTemplateApi.rejected, (state, action) => {
        state.errors.push(action.error.message);
        state.loading = false;
      });
  },
});

export default mediaTemplateSlice.reducer;
